import { observable, action } from "mobx";
import UserInfo from "../models/client/hudsonyards/userInfo";
import SeekerStore from "./seekerStore";
import Fetcher, { IHttpResult } from "../utils/fetcher";
import { Demographics } from "../models/profile";
import { copy } from "../utils/data";

export default class HudsonYardsStore {
  private _store: SeekerStore;
  @observable editUserInfo: UserInfo;
  @observable saved: boolean;
  @observable validated: boolean;
  @observable submitted: boolean;
  @observable showValidationMsg: boolean;
  constructor(store: SeekerStore) {
    this._store = store;
    this.editUserInfo = new UserInfo();
    this.saved = false;
    this.validated = this.submitted = this.showValidationMsg = false;
  }

  @action initApplication = (): void => {
    const demo: Demographics = this._store.profileStore.profile.demographics;
    if (demo) {
      this.editUserInfo.firstName = demo.firstName;
      this.editUserInfo.lastName = demo.lastName;
      this.editUserInfo.email = demo.emailAddress;
      this.editUserInfo.phone = demo.phone;
      this.editUserInfo.veteran = demo.veteran;
      this.editUserInfo.address.street1 = demo.address.street1 || "";
      this.editUserInfo.address.street2 = demo.address.street2 || "";
      this.editUserInfo.address.city = demo.address.city || "";
      this.editUserInfo.address.state = demo.address.state || "";
      this.editUserInfo.address.zip = demo.address.zip || "";  
    }
  }

  getUserInfo = (cb?: () => void): void => {
    Fetcher.get("api/client/hudsonyards/userinfo", action((ui: UserInfo): void => {
      this.editUserInfo = new UserInfo(ui);
      if (cb) { cb();}
    }));
  }
  @action saveUserInfo = (): void => {
    if (this.validateForm()) {
      Fetcher.postWithResult("/api/client/hudsonyards/userinfo", this.editUserInfo, action((resp: IHttpResult): void => {
        if (resp.ok) {
          this.saved = true;
          this.showValidationMsg = false;
          this.submitted = true;
          this.editUserInfo = new UserInfo();
          this.validated = false;
          setTimeout(action((): void => {
            this.saved = false;
          }), 3000);
        } else {
          alert("There was an error sending your information, please try again later.");
        }       
      }));
    } else {
      this.submitted = false;
      this.showValidationMsg = true;
    }
  }

  @action validateForm = (): boolean => {
    this.validated = true;
    if (this.editUserInfo.firstName.length > 0 &&
      this.editUserInfo.lastName.length > 0 &&
      this.editUserInfo.email.length > 0 &&
      this.editUserInfo.phone.length > 0 &&
      ((this.editUserInfo.residentNYCHA && this.editUserInfo.residentLocation !== "") || (!this.editUserInfo.residentNYCHA && this.editUserInfo.residentLocation === ""))) {
      if (this.editUserInfo.homeless) {
        return true;
      } else {
        if (this.editUserInfo.address.street1.length > 0 &&
          this.editUserInfo.address.city.length > 0 &&
          this.editUserInfo.address.zip.length > 4) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  @action handleChange = (e: any): void => {
    this.editUserInfo[e.target.id] = e.target.value;
  }

  @action handleAddressChange = (e: any): void => {
    this.editUserInfo.address[e.target.id] = e.target.value;
  }

  @action handleSelectChange = (e: any, selection: boolean): void => {
    this.editUserInfo[e.target.name] = selection;
    if (e.target.name === "residentNYCHA" && !selection) {
      this.editUserInfo.residentLocation = "";
    }
  }

  @action resetForm = (): void => {
    this.submitted = this.validated = this.showValidationMsg = false;
  }
}



// WEBPACK FOOTER //
// ./src/stores/hudsonYardsStore.ts